import { ISortConfig } from '../api/common/addresses';

export type AddressSortByLabel = keyof typeof addressSortByMap;
export type AddressSortByValue = (typeof addressSortByMap)[AddressSortByLabel];

export const addressSortByMap = {
  'Last Edited': 'lastedited',
  Nickname: 'nickName',
  Company: 'company',
  'Last Name': 'lastName',
  'Street Name': 'streetName',
  Phone: 'phone',
  'Added By': 'addedBy',
} as const;

export const addressSortInputValues: AddressSortByLabel[] = [
  'Last Edited',
  'Nickname',
  'Company',
  'Last Name',
  'Street Name',
  'Phone',
  'Added By',
];

export const addressDefaultSortBy = addressSortInputValues[0];

export const addressDefaultSortConfigs: Record<
  AddressSortByLabel,
  ISortConfig
> = {
  'Last Edited': {
    sortBy: addressSortByMap['Last Edited'],
    ascendingOrder: false,
    page: 1,
  },
  Nickname: {
    sortBy: addressSortByMap.Nickname,
    ascendingOrder: true,
    page: 1,
  },
  Company: { sortBy: addressSortByMap.Company, ascendingOrder: true, page: 1 },
  'Last Name': {
    sortBy: addressSortByMap['Last Name'],
    ascendingOrder: true,
    page: 1,
  },
  'Street Name': {
    sortBy: addressSortByMap['Street Name'],
    ascendingOrder: true,
    page: 1,
  },
  Phone: { sortBy: addressSortByMap.Phone, ascendingOrder: true, page: 1 },
  'Added By': {
    sortBy: addressSortByMap['Added By'],
    ascendingOrder: true,
    page: 1,
  },
} as const;

export const cardSortByMap = {
  'Card Type': {
    value: 'cardBrand',
    orders: ['A to Z', 'Z to A'],
  },
  'Card Number': {
    value: 'cardNumber',
    orders: ['Lowest to Highest', 'Highest to Lowest'],
  },
  Nickname: {
    value: 'nickName',
    orders: ['A to Z', 'Z to A'],
  },
  'Expiration Date': {
    value: 'expiry',
    orders: ['Oldest to Newest', 'Newest to Oldest'],
  },
  Status: {
    value: 'status',
    orders: ['Active First', 'Inactive First'],
  },
  'Added By': {
    value: 'addedBy',
    orders: ['A to Z', 'Z to A'],
  },
  'Phone Authorization': {
    value: 'authorization',
    orders: ['Authorized First', 'Authorized Last'],
  },
  'T2C Authorization': {
    value: 'text2confirm',
    orders: ['Authorized First', 'Authorized Last'],
  },
  'Last Edited Date': {
    value: 'lastedited',
    orders: ['Oldest to Newest', 'Newest to Oldest'],
  },
} as const satisfies Record<
  CardSortByLabel,
  { value: string; orders: readonly string[] }
>;

export const cardSortByPayloadValueMap = Object.entries(cardSortByMap).reduce(
  (acc, [key, value]) => {
    acc[value.value] = key as CardSortByLabel;
    return acc;
  },
  {} as Record<CardSortByValue, CardSortByLabel>,
);

export type CardSortByLabel =
  | 'Card Type'
  | 'Card Number'
  | 'Nickname'
  | 'Expiration Date'
  | 'Status'
  | 'Added By'
  | 'Phone Authorization'
  | 'T2C Authorization'
  | 'Last Edited Date';

export type CardSortByValue = (typeof cardSortByMap)[CardSortByLabel]['value'];

export const cardSortInputValues = Object.keys(
  cardSortByMap,
) as CardSortByLabel[];
